import localforage from 'localforage';

localforage.config({
    driver: localforage.INDEXEDDB,
    name: 'severino',
    version: import.meta.env.VITE_APP_VERSION,
    storeName: 'severino_db',
    description: 'Database used for voucher storage'
})